import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputText from 'shared/ui/Input/InputText';
import TextArea from 'shared/ui/TextArea/TextArea';

import styles from './NameDescriptionFields.module.scss';

export const NAME_MAX = 255;
export const DESCRIPTION_MAX = 2000;

interface INameDescriptionFieldsProps {
    control: Control<any>,
    register: UseFormRegister<any>,
    nameError?: string,
    descriptionError?: string,
    namePlaceholder: string,
    descriptionPlaceholder: string,
    descriptionRows: number,
}

const NameDescriptionFields: React.FC<INameDescriptionFieldsProps> = ({
    control,
    register,
    nameError,
    descriptionError,
    namePlaceholder,
    descriptionPlaceholder,
    descriptionRows,
}) => (
    <>
        <FormGroupWithError
            error={nameError}
            className={styles.group}
            label={t`Название`}
        >
            <InputText
                control={control}
                register={register}
                name="name"
                placeholder={namePlaceholder}
                validate={false}
                rules={{
                    validate: (v: string) => (v && v.trim().length > 0) || t`Введите название`,
                    maxLength: {value: NAME_MAX, message: t`Максимум ${NAME_MAX} символов`},
                }}
            />
        </FormGroupWithError>

        <FormGroupWithError
            error={descriptionError}
            className={styles.group}
            label={t`Описание`}
        >
            <TextArea
                register={register}
                name="description"
                placeholder={descriptionPlaceholder}
                rows={descriptionRows}
                constraints={{
                    maxLength: {
                        value: DESCRIPTION_MAX,
                        message: t`Максимум ${DESCRIPTION_MAX} символов`,
                    },
                }}
            />
        </FormGroupWithError>
    </>
);

export default NameDescriptionFields;
